import Image from 'next/image';
import SvgDocument from '@public/assets/pages/interwill/document.svg';
import styled from 'styled-components';

import { StepBodyIntroduction } from '@/_pages/interwill/components/Progress/StepBodies/StepBodyIntroduction';
import { useIwBreakPoints } from '@/_pages/interwill/hooks/useIwBreakPoints';
import { media } from '@/shared/components';

export const Introduction = () => {
  const { isMobile } = useIwBreakPoints();

  return (
    <Overview>
      {!isMobile && <ImageDesktop src={SvgDocument} width={130} height={170} alt="doc" />}
      <Info>
        <StepBodyIntroduction />
      </Info>
    </Overview>
  );
};

const Overview = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  padding: 24px;
  pointer-events: none;

  ${media.iwMobile} {
    padding: 0;
    overflow: hidden;

    * {
      border: none;
    }
  }
`;

const ImageDesktop = styled(Image)`
  display: block;
`;

const Info = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
